import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { RulesColors } from "../../../../domain/enums";
import { AutopilotRule } from "../../../../domain/rule";
import { AutopilotRepository } from "../../../../domain/autopilot-repository";
import { Logger } from "../../../../infrastructure/logger";
import { UI } from "../../../../services/ui.service";

@Component({
  selector: "rule-library-item",
  templateUrl: "./ruleLibraryItem.component.html",
  styleUrls: ["./ruleLibraryItem.component.scss"],
})
export class RuleLibraryItemComponent {
  @Input()
  item: AutopilotRule;

  @Input()
  viewMode: string = "gallery";

  backgroundColor;

  @Output()
  deleteRule = new EventEmitter();

  constructor(
    private router: Router,
    private autopilotRuleRepository: AutopilotRepository,
    private changeDetectorRef: ChangeDetectorRef,
    private logger: Logger,
    private ui: UI,
  ) {}

  /**
   * Initializing Component
   * @return void
   */
  ngOnInit() {
    this.backgroundColor = RulesColors[this.item["color"]];
  }

  /**
   * Editing Graphic Element
   * @return void
   */
  deleteGraphic() {
    this.ui.notify(this.ui.EVENTS.ShowConfirm, {
      title: "Delete autopilot rule",
      message: "Are you sure about that?",
      buttons: [
        {
          title: "Yes",
          callback: this.onDeleteConfirmed.bind(this),
        },
        {
          title: "No",
          callback: this.onDeleteCancelled.bind(this),
        },
      ],
    });
  }

  /**
   * Dispatched when delete operation is confirmed
   * @return void
   */
  onDeleteConfirmed() {
    this.deleteRule.emit();
  }

  onDeleteCancelled() {}

  /**
   * Editing Graphics Tempate
   * @return void
   */
  editGraphics() {
    this.router.navigate(["/autopilot/edit/", this.item.id]);
  }

  toggleActiveState() {
    return this.autopilotRuleRepository
      .setActiveState(this.item.id, !this.item.isActive)
      .then(() => {
        return true;
      })
      .catch((err) => {
        this.logger.error(
          "Could not change active state to " +
            !this.item.isActive +
            "; RuleId: " +
            this.item.id,
        );
        return false;
      });
  }
}
